<template>
  <div
    tabindex="0"
    class="interaction-head display-minimum web-embed web-embed-display-minimum mb-0"
    :class="enabledFeatures.includes('hotspotStyling') ? '' : 'pt-2 px-2'"
    :aria-label="`Interaction text: ${localInteraction.interactionText.stripHTML(['img', 'Image'], ['input', 'Input blank'])}`"
  >
    <v-layout
      justify-center
      align-center
      class="mb-1"
    >
      <a
        :href="localInteraction.interactionText"
        target="_blank"
      >
        {{localInteraction.interactionText}}
      </a>
    </v-layout>
    <iframe
      frameborder="0"
      width="100%"
      height="350px"
      :src="localInteraction.interactionText"
      tabindex="-1"
      class="mb-2"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
    ></iframe>
    <InteractionAttachments :attachments="localInteraction.interactionAttachments" />
  </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'WebEmbedDisplayMinimumInteractionHead',
  components: {
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
  props: {
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
  },
};
</script>
